<template>
  <div
    class="user-avatar-with-badge"
    :class="badgeSizeClass"
    :style="avatarStyle"
  >
    <el-avatar
      :size="numericSize"
      :shape="shape"
      :fit="fit"
      :src="src"
    />
    <span
      v-if="subscriptionBadge"
      class="user-subscription-badge"
      :class="`is-${subscriptionBadge.toLowerCase()}`"
    >{{ subscriptionBadge }}</span>
  </div>
</template>

<script>
export default {
  name: 'UserAvatarBadge',
  props: {
    src: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 25
    },
    shape: {
      type: String,
      default: 'circle'
    },
    fit: {
      type: String,
      default: 'cover'
    },
    subscriptionKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    numericSize() {
      const size = Number(this.size)
      return Number.isFinite(size) && size > 0 ? size : 25
    },
    avatarStyle() {
      return {
        width: `${this.numericSize}px`,
        height: `${this.numericSize}px`
      }
    },
    badgeSizeClass() {
      if (this.numericSize >= 48) return 'is-large'
      if (this.numericSize >= 32) return 'is-medium'
      return 'is-small'
    },
    subscriptionBadge() {
      const subscriptionKey = String(this.subscriptionKey || '').toUpperCase()
      if (!subscriptionKey || subscriptionKey.includes('FREE')) return ''

      const isSvip = /(^|_)(SVIP|PRO|PROFESSION|PROFESSIONAL|PREMIUM|ULTIMATE)(_|$)/.test(subscriptionKey)
      return isSvip ? 'SVIP' : 'VIP'
    }
  }
}
</script>

<style lang="scss" scoped>
.user-avatar-with-badge {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;

  .el-avatar {
    width: 100%;
    height: 100%;
  }
}

.user-subscription-badge {
  position: absolute;
  z-index: 1;
  left: 50%;
  box-sizing: border-box;
  border: 1px solid #f4c75e;
  background: linear-gradient(180deg, #fff0aa 0%, #f4b83f 100%);
  box-shadow: 0 1px 2px rgba(49, 25, 0, 0.38);
  color: #633500;
  font-weight: 800;
  text-align: center;
  transform: translateX(-50%);
  pointer-events: none;

  &.is-svip {
    border-color: #ff9b3f;
    background: linear-gradient(180deg, #ffd36a 0%, #f47b2d 100%);
    color: #572100;
  }
}

.is-small .user-subscription-badge {
  bottom: -4px;
  min-width: 20px;
  height: 10px;
  padding: 0 2px;
  border-radius: 5px;
  font-size: 7px;
  line-height: 8px;
  letter-spacing: -0.2px;

  &.is-svip {
    min-width: 24px;
  }
}

.is-medium .user-subscription-badge {
  bottom: -5px;
  min-width: 25px;
  height: 12px;
  padding: 0 3px;
  border-radius: 6px;
  font-size: 8px;
  line-height: 10px;

  &.is-svip {
    min-width: 30px;
  }
}

.is-large .user-subscription-badge {
  bottom: -6px;
  min-width: 34px;
  height: 16px;
  padding: 0 5px;
  border-radius: 8px;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.2px;

  &.is-svip {
    min-width: 42px;
  }
}
</style>
